// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-pricing-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.add-pricing-container .admin-header {
  margin-bottom: 24px;
}
.add-pricing-container .admin-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}
.add-pricing-container .add-pricing-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.add-pricing-container .add-pricing-form .form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}
@media (max-width: 768px) {
  .add-pricing-container .add-pricing-form .form-grid {
    grid-template-columns: 1fr;
  }
}
.add-pricing-container .add-pricing-form .form-grid .ant-form-item {
  margin-bottom: 0;
}
.add-pricing-container .add-pricing-form .form-grid .ant-form-item:nth-last-child(1) {
  grid-column: 1/-1;
}
.add-pricing-container .add-pricing-form .form-actions {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}
.add-pricing-container .add-pricing-form .form-actions .ant-btn {
  min-width: 120px;
}
.add-pricing-container .ant-input,
.add-pricing-container .ant-input-number,
.add-pricing-container .ant-select-selector {
  border-radius: 4px;
}
.add-pricing-container .ant-form-item-label > label {
  font-weight: 500;
  color: #262626;
}
.add-pricing-container .ant-switch {
  background-color: #d9d9d9;
}
.add-pricing-container .ant-switch.ant-switch-checked {
  background-color: #52c41a;
}`, "",{"version":3,"sources":["webpack://./pages/AddPricing/add-pricing.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACN;AAGE;EACE,iBAAA;EACA,kBAAA;EACA,wCAAA;AADJ;AAKI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAHN;AAKM;EANF;IAOI,0BAAA;EAFN;AACF;AAIM;EACE,gBAAA;AAFR;AAIQ;EACE,iBAAA;AAFV;AAOI;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,iBAAA;AALN;AAOM;EACE,gBAAA;AALR;AAUE;;;EAGE,kBAAA;AARJ;AAWE;EACE,gBAAA;EACA,cAAA;AATJ;AAYE;EACE,yBAAA;AAVJ;AAYI;EACE,yBAAA;AAVN","sourcesContent":[".add-pricing-container {\r\n  padding: 20px;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n\r\n  .admin-header {\r\n    margin-bottom: 24px;\r\n\r\n    h2 {\r\n      font-size: 24px;\r\n      font-weight: 600;\r\n      color: #262626;\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  .add-pricing-card {\r\n    background: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .add-pricing-form {\r\n    .form-grid {\r\n      display: grid;\r\n      grid-template-columns: repeat(2, 1fr);\r\n      gap: 16px;\r\n      margin-bottom: 24px;\r\n\r\n      @media (max-width: 768px) {\r\n        grid-template-columns: 1fr;\r\n      }\r\n\r\n      .ant-form-item {\r\n        margin-bottom: 0;\r\n\r\n        &:nth-last-child(1) {\r\n          grid-column: 1 / -1;\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-actions {\r\n      margin-top: 24px;\r\n      padding-top: 24px;\r\n      border-top: 1px solid #f0f0f0;\r\n      text-align: right;\r\n\r\n      .ant-btn {\r\n        min-width: 120px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ant-input,\r\n  .ant-input-number,\r\n  .ant-select-selector {\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .ant-form-item-label > label {\r\n    font-weight: 500;\r\n    color: #262626;\r\n  }\r\n\r\n  .ant-switch {\r\n    background-color: #d9d9d9;\r\n\r\n    &.ant-switch-checked {\r\n      background-color: #52c41a;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
